import * as React from "react";

const SvgShipment = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Zm0 2h-2v5a1 1 0 0 1-1.458.89l-.097-.058L12 9.202l-2.445 1.63a1 1 0 0 1-1.55-.72L8 10V5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm-4 0h-4v3.13l1.445-.962a1 1 0 0 1 .994-.066l.116.066L14 8.13V5Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

export default SvgShipment;
